var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show,"persistent":"","scrollable":"","width":"500px"}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-title',[_vm._t("title")],2),_c('v-card-subtitle',[_vm._t("card-image")],2),_c('v-card-text',[_vm._t("message")],2),_c('v-card-actions',[_vm._t("card-action")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }